// DEPENDENCIES ---------------------------------------------------------------- //

// import React from 'react';

import { useTheme } from '@mui/material';

import Tile, { TileProps } from '@components/Timeline/Tile/Tile';

// TYPES ---------------------------------------------------------------- //

export interface LoanerDriveProps
  extends Omit<
    TileProps,
    'color' | 'extraWidthBeforeLabel' | 'extraWidthBetweenLabel' | 'extraWidthAfterLabel' | 'secondaryIcon' | 'variant'
  > {}

// COMPONENT ---------------------------------------------------------------- //

const LoanerDrive = ({ ...props }: LoanerDriveProps) => {
  const theme = useTheme();

  return (
    <Tile
      color={theme.palette.loaner.main}
      extraWidthBeforeLabel={'PICKUP'}
      extraWidthBetweenLabel={'DRIVE'}
      extraWidthAfterLabel={'DELIVERY'}
      secondaryIcon={null}
      variant={'solid'}
      {...props}
    />
  );
};

// EXPORT ---------------------------------------------------------------- //

export default LoanerDrive;
